import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const SkillCard = ({ title, text }) => (
  <Box
    sx={{
      // border: '1px solid #ccc',
      borderRadius: 2,
      p: 2,
      minHeight: { xs: 200, sm: 330, md: 350, lg: 370 },
      height: { xs: 'auto', sm: 390, md: 320, lg: 'auto' },
      backgroundColor: '#fff',
      pt: 3,
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Typography variant='h3' sx={{ fontWeight: 700, fontSize: '16px !important', mb: 1, textAlign: 'center' }}>
      {title}
    </Typography>
    <Box sx={{ fontSize: '13px !important', whiteSpace: 'pre-line', textAlign: 'center', flex: 1 }}>
      {text}
    </Box>
  </Box>
);
SkillCard.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
};
export default SkillCard;
